import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function TermAndServices() {
  const [termdata, setTermData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchTermServicesData = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/getCmsContent`,
        {
          post_url: "terms-of-services",
        }
      );

      setTermData(res.data.data);
    } catch (err) {
      console.error("Error fetching policy:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    fetchTermServicesData();
  }, []);
  return (
    <section class="ser_v_araeea faqess">
      <SetMetaTags
        title={termdata?.meta_title}
        description={termdata?.meta_description}
        keywords={termdata?.meta_keyword}
      />

      <div class="container">
        <div class="faq_contentss">
          {loading ? (
            <Skeleton count={5} height={20} style={{ marginBottom: "10px" }} />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: termdata?.content }} />
          )}
        </div>
      </div>
    </section>
  );
}

export default TermAndServices;
